// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__rm+A0","tooltip_box":"Tooltip_tooltip_box__TN81O"};